import { gsap } from 'gsap'

export class Opening {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementsByClassName('p-index_kv').length == 0) return
      window.addEventListener('load', () => {
        const tl = gsap.timeline()
        tl.fromTo('.l-header', { opacity: 0, y: -30 }, { opacity: 1, y: 0 })
        tl.fromTo('.p-index_kv__catch', { opacity: 0, x: -40 }, { opacity: 1, x: 0 })
        tl.fromTo('.p-index_kv__badge', { opacity: 0, scale: 1.05 }, { opacity: 1, scale: 1 })
        tl.fromTo('.p-index_kv__news', { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, '<')
      })
    })
  }
}
